<template>
  <div>
    <span class="historyText"
      >Link:
      <a
        id="link"
        :href="command.data.link"
        :arial-label="command.data.link"
        target="_blank"
        >{{ command.data.link }}</a
      ></span
    >
  </div>
</template>

<script>
export default {
  name: 'openLink',
  props: ['command']
};
</script>

<style scoped>
.historyText {
  white-space: pre-line;
  padding-left: 10px;
  position: relative;
  top: -1px;
  max-width: 90%;
  word-break: break-word;
}

a {
  color: #009b64ba;
}
</style>
